import { render, staticRenderFns } from "./withdrawwals-detail.vue?vue&type=template&id=b9c08f7e"
import script from "./withdrawwals-detail.vue?vue&type=script&lang=js"
export * from "./withdrawwals-detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports